var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4592 12.5639C18.1841 12.5639 17.9611 12.7869 17.9611 13.062V17.4846C17.9601 18.3096 17.2918 18.9782 16.4668 18.9789H2.49052C1.66553 18.9782 0.99718 18.3096 0.996207 17.4846V4.50456C0.99718 3.67977 1.66553 3.01122 2.49052 3.01025H6.91313C7.18826 3.01025 7.41124 2.78727 7.41124 2.51214C7.41124 2.23721 7.18826 2.01404 6.91313 2.01404H2.49052C1.11567 2.01559 0.00155657 3.12971 0 4.50456V17.4848C0.00155657 18.8597 1.11567 19.9738 2.49052 19.9753H16.4668C17.8416 19.9738 18.9558 18.8597 18.9573 17.4848V13.062C18.9573 12.7869 18.7343 12.5639 18.4592 12.5639Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7601 0.732461C17.8847 -0.142917 16.4655 -0.142917 15.5901 0.732461L6.70359 9.61894C6.64269 9.67984 6.59871 9.75534 6.57575 9.83822L5.40715 14.0571C5.35909 14.2301 5.40793 14.4153 5.53479 14.5424C5.66185 14.6692 5.84708 14.7181 6.02006 14.6702L10.239 13.5014C10.3219 13.4785 10.3973 13.4345 10.4582 13.3736L19.3445 4.48692C20.2186 3.61096 20.2186 2.19292 19.3445 1.31695L18.7601 0.732461ZM7.78891 9.94271L15.0618 2.66962L17.4074 5.01518L10.1343 12.2883L7.78891 9.94271ZM7.32038 10.8829L9.1943 12.757L6.60222 13.4752L7.32038 10.8829ZM18.6402 3.78257L18.1119 4.31083L15.7662 1.96507L16.2946 1.43681C16.7809 0.950576 17.5693 0.950576 18.0555 1.43681L18.6402 2.0213C19.1257 2.50812 19.1257 3.29594 18.6402 3.78257Z",
    fill: "#007BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.443fde7e.svg";
export { ForwardRef as ReactComponent };